import {Template, Component} from '@scoutgg/ftw/source/lib'
import template from './create-new-receiver.jade'
import notify from '@scoutgg/ftw/source/services/notification'
import {Receiver} from '../../models'
import '../status'

@Component('sporty')
@Template(template)
export default class CreateNewReceiver extends HTMLElement {
  attached() {
  }

  closeModal() {
    this.parentNode.close()
  }

  async createReceiver() {
    const form = this.shadowRoot.querySelector('form')

    if(!form.checkValidity()) {
      return form.reportValidity()
    }

    try {
      const params = {
        name: form.querySelector('[name=name]').value,
        url: form.querySelector('[name=url]').value,
        isInplayFantasy: form.querySelector('[name=isInplayFantasy]').checked,
      }
      await Receiver.post(params)
      notify('Receiver created', { level: 'success', timeout: 5000 })
      this.parentNode.close({ created: true })
    } catch(err) {
      notify(err.message || err.error, {
        level: 'danger',
        timeout: 10000,
      })
    }
  }
}
